/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEvaluationParameterScopeDto } from './CreateEvaluationParameterScopeDto';
import {
    CreateEvaluationParameterScopeDtoFromJSON,
    CreateEvaluationParameterScopeDtoFromJSONTyped,
    CreateEvaluationParameterScopeDtoToJSON,
} from './CreateEvaluationParameterScopeDto';

/**
 * 
 * @export
 * @interface GetTaskItemEvaluationScopeDto
 */
export interface GetTaskItemEvaluationScopeDto {
    /**
     * 
     * @type {string}
     * @memberof GetTaskItemEvaluationScopeDto
     */
    targetSystemId?: string;
    /**
     * 
     * @type {Array<CreateEvaluationParameterScopeDto>}
     * @memberof GetTaskItemEvaluationScopeDto
     */
    previousScopes?: Array<CreateEvaluationParameterScopeDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GetTaskItemEvaluationScopeDto
     */
    $type?: GetTaskItemEvaluationScopeDtoTypeEnum;
}


/**
 * @export
 */
export const GetTaskItemEvaluationScopeDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetTaskItemEvaluationScopeDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.GetTaskItemEvaluationScopeDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetTaskItemEvaluationScopeDtoTypeEnum = typeof GetTaskItemEvaluationScopeDtoTypeEnum[keyof typeof GetTaskItemEvaluationScopeDtoTypeEnum];


/**
 * Check if a given object implements the GetTaskItemEvaluationScopeDto interface.
 */
export function instanceOfGetTaskItemEvaluationScopeDto(value?: unknown): value is GetTaskItemEvaluationScopeDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetTaskItemEvaluationScopeDtoTypeEnum)[0];
}

export function GetTaskItemEvaluationScopeDtoFromJSON(json: any): GetTaskItemEvaluationScopeDto {
    return GetTaskItemEvaluationScopeDtoFromJSONTyped(json, false);
}

export function GetTaskItemEvaluationScopeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTaskItemEvaluationScopeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetSystemId': !exists(json, 'targetSystemId') ? undefined : json['targetSystemId'],
        'previousScopes': !exists(json, 'previousScopes') ? undefined : (json['previousScopes'] === null ? null : (json['previousScopes'] as Array<any>).map(CreateEvaluationParameterScopeDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function GetTaskItemEvaluationScopeDtoToJSON(value?: GetTaskItemEvaluationScopeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'targetSystemId': value.targetSystemId,
        'previousScopes': value.previousScopes === undefined ? undefined : (value.previousScopes === null ? null : (value.previousScopes as Array<any>).map(CreateEvaluationParameterScopeDtoToJSON)),
        '$type': value.$type,
    });
}

